import React, { useEffect, useMemo, useState } from "react";
import { Add as AddIcon, ManageAccounts as ManageAccountsIcon } from "@mui/icons-material";
import { ListToolbar } from "../../components/organisms/list";
import { FILTER_TABS, ROLE_OPTIONS } from "./constants";

const ROLE_TPL_STORAGE_KEY = "pupill:adminRoleTemplates";
function loadStoredTemplates() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(ROLE_TPL_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : [];
  } catch (_e) { return []; }
}

/**
 * Kullanıcı Yönetimi sayfasının üst barı — ListToolbar konfigürasyonu.
 * Rol/şablon filtresi bir dropdown'dır (sekme değil). `staff` scope'unda
 * dropdown, admin rol şablonlarını listeler (`Şablon`); diğer scope'larda
 * sabit `ROLE_OPTIONS` listesi kullanılır (`Rol`).
 */
export default function UsersToolbar({
  filters,
  onFilterChange,
  onClear,
  pending = {},
  counts,
  filteredCount,
  isLoading = false,
  onCreate,
  canCreate,
  title,
  subtitle,
  scope,
}) {
  const isStaffScope = scope === "staff";

  const [templates, setTemplates] = useState([]);
  useEffect(() => {
    if (isStaffScope) setTemplates(loadStoredTemplates());
  }, [isStaffScope]);

  const roleOptions = isStaffScope
    ? [
        { value: "", label: "Tümü" },
        ...templates.map((t) => ({
          value: `tpl:${t._id}`,
          label: `${t.name} (${(t.permissions || []).length} izin)`,
        })),
      ]
    : ROLE_OPTIONS;
  const roleLabel = isStaffScope ? "Şablon" : "Rol";

  const filterTabs = useMemo(
    () => ({
      filters: FILTER_TABS.map((tab) => ({
        ...tab,
        count: counts[tab.countKey],
      })),
      activeFilter: filters.status,
      onChange: (id) => onFilterChange("status", id),
      isLoading,
    }),
    [counts, filters.status, onFilterChange, isLoading]
  );

  const actionItems = canCreate
    ? [
        {
          label: "Personel Oluştur",
          icon: <AddIcon sx={{ fontSize: 18 }} />,
          onClick: onCreate,
          variant: "primary",
        },
      ]
    : [];

  return (
    <ListToolbar
      icon={<ManageAccountsIcon sx={{ fontSize: 18 }} />}
      title={title}
      subtitle={subtitle}
      count={filteredCount}
      countLabel="kullanıcı"
      isLoading={isLoading}
      actionItems={actionItems}
      filterTabs={filterTabs}
      searchFields={[
        {
          key: "searchName",
          placeholder: "Ad veya soyad",
          value: filters.searchName,
          onChange: (v) => onFilterChange("searchName", v),
          isPending: pending.searchName,
        },
        {
          key: "searchEmail",
          placeholder: "E-posta",
          value: filters.searchEmail,
          onChange: (v) => onFilterChange("searchEmail", v),
          isPending: pending.searchEmail,
        },
        {
          key: "searchTcNo",
          placeholder: "TC Kimlik No",
          value: filters.searchTcNo || "",
          // Yalnız rakam, en fazla 11 hane.
          onChange: (v) => onFilterChange("searchTcNo", String(v || "").replace(/\D/g, "").slice(0, 11)),
          isPending: pending.searchTcNo,
        },
        {
          key: "role",
          type: "select",
          placeholder: roleLabel,
          options: roleOptions,
          value: filters.role,
          onChange: (v) => onFilterChange("role", v),
          sx: { width: { xs: "100%", sm: 200 } },
        },
      ]}
      onClear={onClear}
    />
  );
}
